var path = 'public/app/plugins/panel/sensor/partials/tab.html';
var html = "<div class=\"section gf-form-group\">\n\n  <div ng-repeat=\"sensorTarget in ctrl.panel.sensorTargets\">\n    <h5 class=section-heading>{{ sensorTarget.sensorShortName }}</h5>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-7\">Alias</span>\n      <input type=text class=\"gf-form-input width-25\" ng-model-options=\"{ debounce: 250 }\" ng-model=sensorTarget.alias ng-change=\"ctrl.aliasChanged(sensorTarget.sensorShortName, sensorTarget.alias)\">\n      \n    </div>\n    <br>\n  </div>\n\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./public/app/plugins/panel/sensor/partials/tab.html
// module id = 1163
// module chunks = 3